/** Category names match case- and space-insensitively (backend naming.normalize). */
export const normName = (s: string) => s.trim().replace(/\s+/g, ' ').toLocaleLowerCase()
export const cleanName = (s: string) => s.trim().replace(/\s+/g, ' ')

export function relTime(iso: string | null | undefined, lang: string, now = Date.now()): string {
  if (!iso) return ''
  const s = Math.round((new Date(iso).getTime() - now) / 1000)
  const fmt = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' })
  const abs = Math.abs(s)
  if (abs < 60) return fmt.format(s, 'second')
  if (abs < 3600) return fmt.format(Math.round(s / 60), 'minute')
  if (abs < 86400) return fmt.format(Math.round(s / 3600), 'hour')
  return fmt.format(Math.round(s / 86400), 'day')
}
